import _ from 'lodash';
import { GRANULARITY_TYPES } from '../useProgressionOverTime/state.types';
import { LBTabs, LBTabsList, LBTabsTrigger } from '@linearb/buzz';

const GranularityToggler = ({ granularity, onChange }) => {
  return (
    <div className='leading-normal tracking-normal'>
      <LBTabs
        value={granularity.key}
        onValueChange={granularityKey =>
          onChange(GRANULARITY_TYPES[granularityKey])
        }
      >
        <LBTabsList>
          {_.map(GRANULARITY_TYPES, currGranularity => {
            return (
              <LBTabsTrigger
                key={currGranularity.key}
                value={currGranularity.key}
              >
                {currGranularity.name}
              </LBTabsTrigger>
            );
          })}
        </LBTabsList>
      </LBTabs>
    </div>
  );
};

export default GranularityToggler;
